import type { TariffResponse, UpsertTariffRequest } from '@jq4race/shared';

import { request } from './client.js';

export async function getLocationTariff(locationId: string): Promise<TariffResponse> {
  return request<TariffResponse>(`/admin/locations/${encodeURIComponent(locationId)}/tariff`, {
    method: 'GET',
  });
}

export async function upsertLocationTariff(
  locationId: string,
  input: UpsertTariffRequest,
): Promise<TariffResponse> {
  return request<TariffResponse>(`/admin/locations/${encodeURIComponent(locationId)}/tariff`, {
    method: 'PUT',
    body: input,
  });
}
